module.exports = __webpack_public_path__ + "static/media/COS_FOOTER_BIEN_ETRE.c88fd99d.png";